import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {
  transform(value: any): any {
    if (value) {
      let num = value.replace(/[^a-zA-Z0-9]/g, '');
      // (960) 344-2345
      return (
        '(' +
        num.substring(0, 3) +
        ') ' +
        num.substring(3, 6) +
        '-' +
        num.substring(6, num.length)
      );
    }
    return null;
  }
}
